module.exports = __webpack_public_path__ + "img/door_handle.e65b80ae.png";